import biApi from "../../../../api/biApi";
import type { SmartViewWidget } from "../../../../api/types/dashboardsTypes";
import type { TileObjectSmartView } from "../models/TileObject";

export const convertReportToDashboardReport = async (
  tile: TileObjectSmartView,
  widget: SmartViewWidget,
  onTileUpdate: (tile: TileObjectSmartView) => void
) => {
  try {
    const response = await biApi.uiReports.generateDashboardReport({ reportId: widget.reportId });
    if (response.error || !response.data) {
      onTileUpdate?.({
        ...tile,
        isInitialized: true,
        initializationError: response.error?.message ?? "Unable to add SmartView widget",
      });
    } else {
      onTileUpdate?.({
        ...tile,
        isInitialized: true,
        item: {
          ...tile.item,
          widget: {
            ...tile.item.widget,
            reportId: response.data.reportId,
            nameUserInput: response.data.name,
            isDraft: true,
          },
        },
      });
    }
  } catch {
    onTileUpdate?.({
      ...tile,
      isInitialized: true,
      initializationError: "Unable to add SmartView widget",
    });
  }
};
